export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const UPDATE_LOCAL_USER = "UPDATE_LOCAL_USER";

export const LOADING    = "LOADING";
export const LOADED     = "LOADED";

export const PLAY = "PLAY";
export const PAUSE = "PAUSE";
export const CHANGE_FILE = "CHANGE_FILE";
export const CLOSE_PLAYER = "CLOSE_PLAYER";
export const SET_PLAYER = "SET_PLAYER";

export const ALERT = "ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";

export const PURCHASE = "PURCHASE";
export const CLEAR_PURCHASE = "CLEAR_PURCHASE";
